"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CopyrightWithLinks = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _ContentRoot = require("../ContentRoot");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CopyrightWithLinks = () => {
  const {
    copyrightLinks,
    copyrightTitle
  } = (0, _hooks.useFooter)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  if (!copyrightTitle) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ContentRoot.ContentRoot, {
    testId: getTestId(_constants.COPYRIGHT_WITH_LINKS),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CopyrightTitle, {
        children: copyrightTitle
      }), copyrightLinks.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Links, {
        children: copyrightLinks.map(link => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLink, {
          href: link.url ?? '',
          title: link.title,
          children: link.title
        }, link.title))
      }) : null]
    })
  });
};
exports.CopyrightWithLinks = CopyrightWithLinks;